import { CarModelResource as Res } from '@shared/resources/car-model';
import { CarModelCreateUpdateDto as DTO } from '@shared/dto/car-model';
import { CarModelService } from '@/services/car-model.service';
import { defineCrudStore } from '@/stores/crud-store';

export const useCarModelsStore = defineCrudStore<DTO, DTO, Res>({
  storeId: 'carModels',
  service: new CarModelService(),
});
